import React, { useState, useEffect } from "react";
import { Row } from "react-bootstrap";
import "./ReviewsPage.css";
import { postRequestcall } from "../../comman/util/postRequest";
import { connect } from "react-redux";
import profile_default from "../../../assets/profile_default.png";
import store_default from "../../../assets/store_default.png";
import { Rating } from "react-simple-star-rating";
import NodatafoundPage from "../../nodatafound/components/NodatafoundPage";
import reviews_org from "../../../assets/no_reviews.svg";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useNavigate } from "react-router-dom";
import { MY_RATING, RATING_LIST } from "../../constants/apiurl";
import { getRequestcall } from "../../comman/util/getRequest";
import { toast } from "react-toastify";
import { clearStoredetail } from "../../dashboard/redux/actions";
import { fetchLogindata } from "../../login/redux/actions";
import moment from "moment";

function ReviewsPage(props) {
  const { t } = useTranslation();
  const [ratinglist, setRatinglist] = useState([]);
  let getType = window.location.pathname.split("/");
  const [nodata, setNodata] = useState(false);
  const navigate = useNavigate();

  // eslint-disable-next-line
  useEffect(() => {
    (async () => getRatinglist())();
    // eslint-disable-next-line
  }, []);

  const getRatinglist = async () => {
    let getResponse;
    if (getType[1] === "vendor") {
      props?.fetchHeaderContent(t("pages.sidenav.reviews"), "", "");
      let geturl = RATING_LIST + `/${props?.storeDetail?.store_id}?page=${"1"}`;
      getResponse = await getRequestcall(geturl, props?.access_token);
    } else {
      props?.fetchHeaderContent(t("pages.sidenav.myreviews"), "", "");
      getResponse = await postRequestcall(MY_RATING, props?.access_token, "");
    }
    if (getResponse?.status === 200) {
      let getlist = await getResponse.json();
      if (getlist?.data?.data?.length === 0) {
        setNodata(true);
      } else {
        setNodata(false);
        setRatinglist(getlist?.data?.data);
      }
    } else if (getResponse?.status === 400) {
      props?.clearStoredetail([]);
      props.logindata.type = "user";
      props.fetchLogindata(props.logindata);
      let getError = await getResponse.json();
      toast.error(getError?.errors);
      navigate("/vendor/");
    }
    else if (getResponse.status === 401) {
      navigate("/", { state: { autologout: true } });
    }
  };

  if (nodata) {
    return (
      <NodatafoundPage
        className={"main-content reviews-centent"}
        image={reviews_org}
        button={t("pages.backtodashboard")}
        title={t("pages.myreviews.noreview")}
        description={t("pages.myreviews.no_reviews")}
        navigation={"/vendor/dashboard"}
      />
    );
  }

  return (
    <div className="user-reviews-centent">
      <div className="block-inline">
        <div className="left-side">
          <h5 className="header-title">{t("pages.myreviews.title")}</h5>
        </div>
      </div>
      <Row className="reviews-list mt-3">
        {ratinglist.map((item, index) => (
          <div key={index.toString()} className="col-12 mb-3">
            <div className="card reviews">
              <div className="card-body">
                <div className="user-info align-items-center">
                  <div className="card-image">
                    <LazyLoadImage
                      className="rounded"
                      onError={(e) => {
                        e.target.src = store_default;
                      }}
                      src={
                        getType[1] === "vendor"
                          ? item?.user_details?.image_url === null
                            ? profile_default
                            : item?.user_details?.image_url
                          : item.storeimage
                      }
                      alt={""}
                    ></LazyLoadImage>
                  </div>
                  <div className="review-from">
                    <h5 className="pr-text mb-0">
                      {getType[1] === "vendor"
                        ? item?.user_details?.first_name
                        : item.storename}
                    </h5>
                    <label className="date-text">
                        {moment(item?.created_at).format("DD-MM-YYYY hh:mm A")}
                    </label>
                    <div className="rating">
                      <label className="">{item.rating}</label>
                      <Rating
                        initialValue={item.rating}
                        readonly={true}
                        size={20}
                        fillColor={"var(--pr-color)"}
                        allowHalfIcon
                      />
                    </div>
                  </div>
                </div>
                <hr className="v-hr" />
                <div className="product-info">
                  <div className="review-from">
                    <label className="sc-text">{item.review}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Row>
    </div>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  storeDetail: state?.dashboard?.storeDetail,
  logindata: state?.login?.logindata,
});

export default connect(mapStateToProps, { fetchHeaderContent, clearStoredetail, fetchLogindata })(ReviewsPage);
